export default __webpack_public_path__ + "static/media/a.ba5a356e.jpg";